import 'core-js'; // polyfill for IE11 and old Android browsers.

import Vue from 'vue';
import Buefy from 'buefy';
import VueGtag from 'vue-gtag';
import errorHandler from '@/util/errorHandler';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import App from '@/App.vue';
import '@/assets/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

Vue.use(Buefy);

if (process.env.VUE_APP_GA_TRACKING_ID) {
  Vue.use(VueGtag, {
    config: {
      id: process.env.VUE_APP_GA_TRACKING_ID,
      params:
        process.env.NODE_ENV !== 'production'
          ? {
              debug_mode: true
            }
          : {}
    }
  });
}

Vue.config.productionTip = false;
Vue.config.errorHandler = errorHandler;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
